import { apiRoutes } from "../services/apiRoutes";
import { DateFormater } from "../services/DateFormater";

export const DefaultTextData = (props) => {
    const { adjustForTimezone } = DateFormater();

    const getDefaultTextData = async () => {
        let json = await props.execute("GET", apiRoutes.defaultText.GetDefaultTexts);
        let defaultTexts = json.map(x => {
            if (x.timestampModified != null) {
                x.timestampModifiedDisplay = adjustForTimezone(x.timestampModified, props.customer.TimezoneId ?? 0);
                x.timestampModified = adjustForTimezone(x.timestampModified, props.customer.TimezoneId ?? 0);
            }

            x.customerPortal = x.publicSites.map(x => x.name).join(", ");
            return x;
        });

        return defaultTexts;
    }

    const deleteDefaultText = async (DefaultTextId) => {
        await props.execute("DELETE", apiRoutes.defaultText.delete(DefaultTextId));
    }

    const postDefaultText = async (selectedDefaultTextName, DefaultTextValues, selectedDefaultText) => {
        if (selectedDefaultText == null)
            selectedDefaultText = {};
        selectedDefaultText.DefaultText = [];
        selectedDefaultText.Name = selectedDefaultTextName;
        selectedDefaultText.id = selectedDefaultText.defaultTextId;

        if (selectedDefaultText.id == null)
            selectedDefaultText.id = 0;

        DefaultTextValues.forEach(x => {
            selectedDefaultText.DefaultText.push({ item1: x.localeId, item2: (x.defaultText === "" || x.defaultText === "<p></p>") ? null : x.defaultText })
        });
        
        await props.execute("POST", apiRoutes.defaultText.post(), selectedDefaultText);
    }

    const assignDefaultTextToSites = async (sitesSelected, DefaultTextId) => {
        let siteIds = sitesSelected.map(x => x.value).join(",");
        if (siteIds === "")
            siteIds = null;
        await props.execute("POST", apiRoutes.defaultText.AssignDefaultTextToSites(DefaultTextId), siteIds);
    }

    const getDefaultText = (DefaultTextId, originalDefaultTexts, localesDropdownData) => {
        let DefaultText = originalDefaultTexts.DefaultText(x => x.id === DefaultTextId);
        if (DefaultText.length > 0)
            DefaultText = JSON.parse(JSON.stringify(DefaultText[0]));
        else
            DefaultText = {};

        let lSelected = [];

        let ExactMatchInclude = [];
        let LocationExclude = [];

        DefaultText.searchMaterialDefaultTexts.forEach(x => {
            if (x.exactMatchInclude != null)
                ExactMatchInclude.push(x.exactMatchInclude);
            if (x.languageId != null) {
                let item = localesDropdownData.DefaultText(y => y.languageId === x.languageId)[0];
                lSelected.push(item);
            }
            if (x.locationExclude != null) LocationExclude.push(x.locationExclude);
        });

        return {
            lSelected, includeExcludeValues: { LocationExclude, ExactMatchInclude }, DefaultText
        };
    }

    return {
        getDefaultTextData, deleteDefaultText, postDefaultText, assignDefaultTextToSites, getDefaultText
    };
}